import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { isTokenExpired } from '../utils/jwtUtils';
import { authService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token and replace {schoolId} placeholder in URLs
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    const schoolId = localStorage.getItem('schoolId');

    // Check if token is expired before making request
    if (token && isTokenExpired(token)) {
      // Token expired, logout user
      authService.logout();
      // Redirect to login
      window.location.href = '/login';
      return Promise.reject(new Error('Token expired'));
    }

    // Add authorization token
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Replace {schoolId} placeholder in URL with actual schoolId
    if (schoolId && config.url) {
      config.url = config.url.replace('{schoolId}', schoolId);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 (Unauthorized) responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const exceptionReason = error.response?.data?.error;
    if (error.response?.status === 401 && exceptionReason !== 'InvalidUserNameOrPassword') {
        debugger;
      // Token expired or invalid, logout user
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);


export default api;

